import {FieldType, OptionItem} from "@white-label/components/page-builder/models/model.map";


export class EditableFieldModel {
    placeholder: string = '';
    type: string = FieldType.text;
    value: any = '';
    metaData: any = {};
    instance: any;
    options: OptionItem[] = [];

    constructor(placeholder?: string, type?: string, value?: any, instance?: any, options?: any, metaData?: any) {
        if(value){
            this.value = value;
        }

        if(placeholder) {
            this.placeholder = placeholder;
        }
        if(type){
            this.type = type;
        }
        if(instance){
            this.instance = instance;
        }
        if(metaData){
            this.metaData = metaData;
        }
        if(options && Array.isArray(options)) {
            this.options = options;
        }
    }
}
